module.exports = __webpack_public_path__ + "static/media/ico_edit_o.a827b9e6.svg";